import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en/translation.json";
import pl from "./pl/translation.json";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: { translation: en },
      pl: { translation: pl },
    },
    supportedLngs: ["en", "pl"],
    fallbackLng: "pl",
    // IMPORTANT: set a safe SSR language
    lng: "pl",

    interpolation: { escapeValue: false },
    detection: {
      order: ["navigator", "htmlTag"],
    },
  });

export default i18n;
